module.exports = __webpack_public_path__ + "img/bg4.9a5c6a9e.png";